<script>
import form from '@/utils/form';
import BaseField from '@/components/BaseField.vue';
import FormBlock from '@/components/FormBlock.vue';
import FileUploaderSingle from '@/components/file/FileUploaderSingle.vue';
import BaseItemList from '@/components/base/BaseItemList.vue';
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'GuideFormPage',
  controller: null,
  components: {
    BaseField,
    FormBlock,
    FileUploaderSingle,
    BasePopup,
    BaseItemList,
  },
  props: {
    guideCategories: Array,
  },
  data() {
    return {
      guideFields: {
        name: form.createFieldObject('string', 'Имя гайда', ''),
        author: form.createFieldObject('string', 'Автор', ''),
        authorDesc: form.createFieldObject('string', 'Об авторе', ''),
      },
      video: null,
      preview: null,
      categories: [],
      title: 'Создать гайд',
      isOpened: false,
    };
  },
  methods: {
    async open(data) {
      this.isOpened = true;

      if (data) {
        form.setValues(this.guideFields, data);

        this.video = data.video;
        this.preview = data.preview;
        this.categories = data.categories;
        this.title = 'Редактировать гайд';
      }

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },

    async close(isSave) {
      if (!isSave) {
        const answer = await this.$confirm('Изменения не сохранятся, закрыть окно?');

        if (answer) {
          this.$options.controller.resolve(null);
          this.isOpened = false;
        }

        return;
      }

      const data = {
        ...form.getValues(this.guideFields),
        video: this.video ? this.video['@id'] : null,
        preview: this.preview ? this.preview['@id'] : null,
        categories: this.categories,
      };

      this.$options.controller.resolve(data);
      this.isOpened = false;
      form.clear(this.guideFields);
    },
  },
};
</script>

<template lang="pug">
BasePopup(v-if="isOpened" @close="close(false)")
  .b-guide-content-form
    FormBlock._form(v-if="guideFields")
      BaseField(
        v-for="(field, name) in guideFields"
        v-model="field.value"
        v-bind="field"
        :key="name"
        labelOuter
      ) {{ field.title }}
    FormBlock._upload-video
      FileUploaderSingle(:file="video" @change="video = $event" title="Загрузить видео")
    FormBlock._upload-preview
      FileUploaderSingle(:file="preview" @change="preview = $event" title="Загрузить заставку")
    FormBlock._categories
      ._title Выбрать категорию
      BaseItemList(:items="guideCategories" v-model="categories" addButtonTitle="Добавить категорию" prompt="Укажите название категории")
    ._buttons
      Btn(@click="close(true)") Сохранить
      Btn(@click="close(false)" grey) Отмена
</template>

<style scoped lang="scss">
::v-deep .wrap {
  background: #F8F9FC;
}

.guide-content-form {
  display: grid;
  grid-template-columns: 400px 400px 400px;
  gap: 40px;
  align-items: start;
  padding: 40px 40px 20px;

  &__buttons {
    grid-row: 3;
    grid-column: 1 / 3 span;
    display: flex;
    align-items: flex-end;
    gap: 20px;
  }

  &__form {
    display: grid;
    gap: 15px;
  }

  &__categories {
    display: flex;
    flex-direction: column;
    gap: 30px;
    grid-row: 2;
    grid-column: 1 / 3 span;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
